define((require, exports, module) => {
    'use strict';

    const UploadFail = require('./UploadFail');

    /**
     * @constructor
     * @extends {UploadFail}
     * @param {Error} stack
     * @param {string} source
     */
    function UnsupportedFolderTransferFail() {
        // eslint-disable-next-line prefer-rest-params
        UploadFail.apply(this, arguments);
    }

    /**
     * @param {DOMException|FileError} error
     * @returns {boolean}
     */
    UnsupportedFolderTransferFail.isNotReadableError = function(error) {
        let isNotReadableError = false;

        if (window.FileError && error instanceof window.FileError) {
            // Safari
            isNotReadableError =
                error.code === window.FileError.NOT_READABLE_ERR;
        }

        return isNotReadableError;
    };

    UnsupportedFolderTransferFail.prototype = Object.assign(
        Object.create(UploadFail.prototype),
        {
            constructor: UnsupportedFolderTransferFail,
            className: 'UnsupportedFolderTransferFail',
            radarName: 'fail_{SOURCE}_unsupported-folder-transfer',
            message: 'Браузер не поддерживает загрузку папок.',
        },
    );

    module.exports = UnsupportedFolderTransferFail;
});
